import { useTranslation } from 'react-i18next';
import './TagInProgress.scss'

type Props = {
  progress: number
}

export const TagInProgress = ({ progress }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="tag-in-progress">
      <span className='tag-in-progress-text'>{t('InProgress', { progress, ns: 'learningHub' })}</span>
    </div>
  )
}
